const initialState = {
  priorities: {},
  loading: false,
  error: null,
};

const providersPriorityReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROVIDERS_PRIORITY':
      return {
        ...state,
        priorities: action.payload,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default providersPriorityReducer;
